import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-view-request',
    templateUrl: './view-request.component.html',
    styleUrls: ['./view-request.component.scss'],
    standalone: false
})
export class ViewRequestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
